module.exports = __webpack_public_path__ + "static/media/Manual_Different_Fish.11f63c7b.png";